import { groupBy, isNull } from 'lodash';
import React, { useRef } from 'react';
import { IFont, IMarkupLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { FontFamilySelector } from '@meitu/saas-editor-ui/es/components/font-family-selector';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { editor } from '@/instance';
import { toWidgetFormat } from '@/services/font/transform';
import { useStoreState } from '@/store';

export const LabelFontFamily: React.FC<{
    id: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const fonts = useStoreState((state) => state.fontMaterialModel.fonts);
    const usingFonts = editor.font.getUsingList(editor.active.getActiveOriginIndex());
    const groupFonts = useRef(groupBy(toWidgetFormat(fonts), 'category_name'));

    const res = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { label } = layer.data as IMarkupLayerProps;
        return {
            fontFamily: label.fontFamily,
        };
    });

    const onChange = async (data: IFont) => {
        const font_name = data.font_name;
        const layer = editor.stage.getLayer(id, true);
        editor.markupLayer.setAttrOperateOriginData(layer);
        await editor.markupLayer.setLabelFontFamily(id, font_name);
        editor.markupLayer.clearAttrOperateOriginData();
        onAfterChange?.(trackCode);
    };

    const globalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(res)) return null;

    const { fontFamily } = res;

    return (
        <div className="c-markup-panel__item c-markup-label">
            <FontFamilySelector
                value={fontFamily}
                fonts={groupFonts.current}
                usingFonts={usingFonts}
                onChange={onChange}
                enableRemoteSearch={false}
                onDropdownVisibleChange={(e) => {
                    globalWidgetRef.current = e;
                }}
            />
        </div>
    );
});
